import {
  DatagridConfigurable,
  TextField,
  FunctionField,
  BooleanField,
  useListContext
} from 'react-admin';
import { useRowStyle } from '../../../../hooks/useRowStyle';
import { TotalRows } from '../../../helperComponents/TotalRows';
import { BRIDGE_STATUS_COLORS } from '../../../../helpers/googleAdsBridgesConstants';
import { formatDate, isStale } from '../../../../helpers/googleAdsBridgesHelpers';

const renderLastSeen = (record) => (
  <span style={isStale(record.last_seen) ? { color: BRIDGE_STATUS_COLORS.RED } : undefined}>
    {formatDate(record.last_seen)}
  </span>
);

const renderGdye = (record) => {
  const { last_gdye_metric: metric, last_gdye_map: map } = record;
  if (!metric && !map) return 'not yet';

  const labels = Array.isArray(map) ? map.map(([label]) => label) : [];
  const text = [metric, ...labels].filter(Boolean).join(', ');
  const warn = metric && metric !== 'all_conversions';
  return <span style={warn ? { color: BRIDGE_STATUS_COLORS.AMBER } : undefined}>{text}</span>;
};

export const GoogleAdsBridgesDataGrid = () => {
  const rowClassName = useRowStyle();
  const { total } = useListContext();

  return (
    <>
      <TotalRows total={total} />
      <DatagridConfigurable
        rowClick="edit"
        className={`${rowClassName} datagrid-content`}
        bulkActionButtons={false}
      >
        <TextField source="id" label="ID" />
        <TextField source="account_name" label="Account Name" />
        <TextField source="customer_id" label="Account ID" />
        <BooleanField source="enabled" label="Enabled" />
        <TextField source="script_version" label="Script Version" />
        <FunctionField source="last_seen" label="Last Seen" render={renderLastSeen} />
        <FunctionField
          source="last_ok_master_report"
          label="Last OK Master Report"
          render={(record) => formatDate(record.last_ok_master_report)}
        />
        <FunctionField
          source="last_ok_search_terms"
          label="Last OK Search Terms"
          render={(record) => formatDate(record.last_ok_search_terms)}
        />
        <FunctionField source="last_gdye_metric" label="GDYE as last sent" render={renderGdye} />
        <FunctionField
          source="secret_set_at"
          label="Secret Set At"
          render={(record) => formatDate(record.secret_set_at)}
        />
      </DatagridConfigurable>
    </>
  );
};
